import axios from "axios"
import { BASE_URL, VERSION } from "../config"

export default axios.create({
    baseURL: `${BASE_URL}/${VERSION}`,
})
export const axiosPrivate = axios.create({
    baseURL: `${BASE_URL}/${VERSION}`,
})
